/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2020. All Rights Reserved.
 #*
 #*===================================================================
 */

import { createAction, props } from '@ngrx/store';

import { IUserPermissionGroup } from '@models/user-permission.model';

export const load = createAction('[ClientDetails:User Permission Group] Load', props<{ tenantId: string }>());
export const loadSuccess = createAction(
  '[ClientDetails:User Permission Group] Load Success',
  props<{ data: IUserPermissionGroup[] }>()
);
export const loadFailure = createAction(
  '[ClientDetails:User Permission Group] Load Failure',
  props<{ errorMessage: string }>()
);

export const createSuccess = createAction(
  '[ClientDetails:User Permission Group] Create Success',
  props<{ item: IUserPermissionGroup }>()
);
export const updateSuccess = createAction(
  '[ClientDetails:User Permission Group] Update Success',
  props<{ item: IUserPermissionGroup }>()
);
export const removeSuccess = createAction(
  '[ClientDetails:User Permission Group] Remove Success',
  props<{ item: IUserPermissionGroup }>()
);
